import MainNav from "@worldwidegroup/support-ui/dist/Components/MainNav/MainNav";
import { ENVIRONMENT_CONFIG } from "shared/globals";
import "react-notifications-component/dist/theme.css";
import styles from "./App.module.css";

import React, { Suspense, useState } from "react";
import { ReactNotifications } from "react-notifications-component";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { useTitle } from "react-use";

import { NavState } from "@worldwidegroup/support-ui/dist/Components/Nav/useNavState";
import { Auth } from "shared/@auth/Auth";
import { CurrentRouteProvider } from "shared/@hooks/useCurrentRoute";
import { CurrentRouteContext } from "./ExecutiveCommittee/useCurrentRoute.js";
import SectionErrorBoundary from "shared/SectionErrorBoundary";
import LoadingPage from "./shared/LoadingPage";
import ManagementTeam from "./ManagementTeam";

const { pageTitle, externalLinks, flags } = ENVIRONMENT_CONFIG;

function App() {
  useTitle(pageTitle);
  const { hasPermission } = Auth.useContainer();
  const { collapsed: navCollapsed } = NavState.useContainer();
  const [currentRoute, setCurrentRoute] = useState();
  const [isNewSubmitted, setIsNewSubmitted] = useState(0);
  const [isHideInfo, setIsHideInfo] = useState(false);
  const setToggleInfo = () => setIsHideInfo(!isHideInfo);

  return (
    <Router>
      <ReactNotifications />
      <CurrentRouteContext.Provider value={{ currentRoute, setCurrentRoute }}>
        <div className={styles.layout}>
          <MainNav
            fetchManagementTeamNotification={
              flags.fetchManagementTeamNotification &&
              hasPermission("management-team.*")
            }
            auth={Auth}
            navCollapsed={navCollapsed}
            externalLinks={externalLinks}
            currentRoute={currentRoute}
          />

          <main className={styles.main}>
            <SectionErrorBoundary>
              <Suspense fallback={<LoadingPage />}>
                <Switch>
                  {hasPermission("management-team.*") && (
                    <Route path="/management-team">
                      <ManagementTeam
                        isNewSubmitted={isNewSubmitted}
                        isHideInfo={isHideInfo}
                        setToggleInfo={setToggleInfo}
                      />
                    </Route>
                  )}

                  <Route path="*">
                    {hasPermission("management-team.*") ? (
                      <Redirect to="/management-team" />
                    ) : (
                      <NotFound />
                    )}
                  </Route>
                </Switch>
              </Suspense>
            </SectionErrorBoundary>
          </main>
        </div>
      </CurrentRouteContext.Provider>
    </Router>
  );
}
export default App;

function NotFound() {
  return (
    <div className={styles.notFound}>
      <h1>Welcome to WWG Support</h1>
      <p>Choose a section on the left sidebar to get started.</p>
    </div>
  );
}
